var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.65 12.634C25.502 9.122 30.498 9.122 31.35 12.634C31.6093 13.7041 32.3641 14.586 33.3813 15.0075C34.3985 15.4289 35.5559 15.3392 36.496 14.766C39.582 12.886 43.116 16.418 41.236 19.506C40.6636 20.4457 40.5741 21.6022 40.9951 22.6188C41.416 23.6354 42.2969 24.39 43.366 24.65C46.878 25.502 46.878 30.498 43.366 31.35C42.2959 31.6093 41.414 32.3641 40.9925 33.3813C40.5711 34.3985 40.6608 35.5559 41.234 36.496C43.114 39.582 39.582 43.116 36.494 41.236C35.5543 40.6636 34.3978 40.5741 33.3812 40.9951C32.3646 41.416 31.61 42.2969 31.35 43.366C30.498 46.878 25.502 46.878 24.65 43.366C24.3907 42.2959 23.6359 41.414 22.6187 40.9925C21.6015 40.5711 20.4441 40.6608 19.504 41.234C16.418 43.114 12.884 39.582 14.764 36.494C15.3364 35.5543 15.4259 34.3978 15.0049 33.3812C14.584 32.3646 13.7031 31.61 12.634 31.35C9.122 30.498 9.122 25.502 12.634 24.65C13.7041 24.3907 14.586 23.6359 15.0075 22.6187C15.4289 21.6015 15.3392 20.4441 14.766 19.504C12.886 16.418 16.418 12.884 19.506 14.764C21.506 15.98 24.098 14.904 24.65 12.634Z",
    stroke: "#00B3B5",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 6,
    stroke: "#00B3B5",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.54423f54a1e7547bdc7a761633f78dba.svg";
export { ForwardRef as ReactComponent };